module.exports = __webpack_public_path__ + "img/JavaScript.0802a596.jpg";